import boolean from './logic/boolean.svg';
import image from './logic/image.svg';
import number from './logic/number.svg';
import string from './logic/string.svg';
import tokenUnknown from './logic/token-unknown.svg';

export const logic = {
  boolean,
  image,
  number,
  string,
  tokenUnknown,
} as const;
